<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Cargar Documento</h4>
                <button ref="closeEmployeesImportModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form id="document_file_form" method="POST" enctype="multipart/form-data">
                    <div class="form theme-form">
                        <div class="row">
                            <div class="col-sm-12" style="padding: 0px 10px;">
                                <div class="mb-3">
                                    <label>{{ document == "fiscal" ? "Comprobante de Situación Fiscal" : document == "personal" ? "Identificación Oficial (INE o Pasaporte)" : (document == "address" ? "Comprobante de domicilio (no mayor a 3 meses)" : (document == "imss" ? "Vigencia de derechos (IMSS) o Numero del seguro social" : (document == "bank" ? "Carátula de estado de cuenta bancario (BBVA)" : "Hoja de retencion del Credito Infonavit o Fonacot"))) }}</label>
                                    <input class="form-control" type="file" id="document_file" name="document_file" placeholder="">
                                    <input type="hidden" id="type" name="type" :value="document">
                                    <input v-if="employee" type="hidden" id="employee_id" name="employee_id" :value="employee.id">
                                </div>
                            </div>
                        </div> 
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="importDocument">Cargar Documento</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'
 
export default {
    name: 'employees_upload_modal',
    mixins: [],
    props: {

    },
    components: {
        
    }, 
    data(){
        return{
            showModal: true,
            employee: null,
            document: null
        }
    },
    methods: {
        async loadEmployee(employee, document) {
            this.employee = employee;
            this.document = document;
        },
        async importDocument() {
            const form = document.getElementById("document_file_form");
            const formData = new FormData(form);

            let response = await ws.uploadEmployeesDocument(formData);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                this.$emit("imported",response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closeEmployeesImportModal.click();
        }
    }
}
</script>